(() => {
  'use strict';

  const clean = (value, max = 120) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, max);

  const addOption = (select) => {
    let option = [...select.options].find((item) => item.dataset.topic === 'product-request');
    if (option) return option;

    option = document.createElement('option');
    option.value = 'Product niet gevonden / productaanvraag';
    option.dataset.topic = 'product-request';
    option.textContent = 'Product niet gevonden / productaanvraag';

    const advice = [...select.options].find((item) => item.dataset.topic === 'product-advice');
    if (advice) advice.insertAdjacentElement('afterend', option);
    else select.append(option);
    return option;
  };

  const addPanel = (page, form) => {
    let panel = page.querySelector('#productaanvraag');
    if (panel) return panel;

    const messageGroup = page.querySelector('[data-message-step]')?.closest('.pw-contact-group');
    if (!messageGroup) return null;

    const prefix = clean(form.id) || 'PWContact';
    panel = document.createElement('fieldset');
    panel.id = 'productaanvraag';
    panel.className = 'pw-contact-group';
    panel.dataset.contactPanel = '';
    panel.dataset.showFor = 'product-request';
    panel.hidden = true;
    panel.innerHTML = `
      <legend>3. Gegevens van het gezochte apparaat</legend>
      <p class="pw-contact-help">Vul het merk en typenummer zo volledig mogelijk in. Dan controleren we of het apparaat of een passend alternatief leverbaar is.</p>
      <div class="pw-contact-grid">
        <div class="pw-contact-field">
          <label for="${prefix}-request-category">Productcategorie <span aria-hidden="true">*</span></label>
          <input id="${prefix}-request-category" type="text" name="contact[Productaanvraag categorie]" placeholder="Bijvoorbeeld vaatwasser of koelkast" data-required-when-visible>
        </div>
        <div class="pw-contact-field">
          <label for="${prefix}-request-brand">Merk <span aria-hidden="true">*</span></label>
          <input id="${prefix}-request-brand" type="text" name="contact[Productaanvraag merk]" placeholder="Bijvoorbeeld Bosch" data-required-when-visible>
        </div>
        <div class="pw-contact-field">
          <label for="${prefix}-request-model">Type- of modelnummer <span aria-hidden="true">*</span></label>
          <input id="${prefix}-request-model" type="text" name="contact[Productaanvraag typenummer]" placeholder="Neem het nummer zo volledig mogelijk over" data-required-when-visible>
        </div>
        <div class="pw-contact-field">
          <label for="${prefix}-request-alternative">Is een passend alternatief ook goed?</label>
          <select id="${prefix}-request-alternative" name="contact[Passend alternatief gewenst]">
            <option value="Graag overleggen">Graag overleggen</option>
            <option value="Ja">Ja</option>
            <option value="Nee, alleen dit model">Nee, alleen dit model</option>
          </select>
        </div>
        <div class="pw-contact-field pw-contact-field--full">
          <label for="${prefix}-request-source">Waar heeft u het apparaat gezien?</label>
          <input id="${prefix}-request-source" type="text" name="contact[Productaanvraag bron of webadres]" placeholder="Webadres, winkel, folder of andere bron">
          <p class="pw-contact-help">Een webadres of extra omschrijving helpt ons het juiste model terug te vinden.</p>
        </div>
      </div>
    `;

    messageGroup.before(panel);
    return panel;
  };

  const addSourceField = (form, source) => {
    if (!source || form.querySelector('[data-product-request-source]')) return;
    const field = document.createElement('input');
    field.type = 'hidden';
    field.name = 'contact[Bron productaanvraag]';
    field.value = source;
    field.dataset.productRequestSource = 'true';
    form.append(field);
  };

  const initialize = () => {
    const page = document.querySelector('[data-pw-contact-page]');
    const select = page?.querySelector('[data-contact-topic]');
    const form = page?.querySelector('form.pw-contact-form');
    if (!page || !select || !form) return;

    const params = new URLSearchParams(window.location.search);
    const requestedTopic = clean(params.get('contact_topic'), 50);
    const source = clean(params.get('contact_source'), 80);
    const option = addOption(select);
    const panel = addPanel(page, form);

    if (requestedTopic !== 'product-request') return;

    select.value = option.value;
    addSourceField(form, source || 'homepage_search');
    select.dispatchEvent(new Event('change', { bubbles: true }));

    window.requestAnimationFrame(() => {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      panel?.scrollIntoView({ block: 'start' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
